import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import React from "react";

export const GlobalServiceDistribution = ({ headers, rows, countries }) => {

    function getUtilValue(componentId) {
       const obj = rows?.filter((x) => x.componentId === componentId);
        return obj[0] ? Number(obj[0]?.blendedComponentPercent.toFixed(2)).toLocaleString("en", { useGrouping: true, roundingMode: "trunc", minimumFractionDigits:2 }):'0.00';
    }   
    return (
            <TableContainer component={Paper}>
                <Table  sx={{ minWidth: 400 }} aria-label="customized table" >
                    <TableHead>
                        <TableRow>
                            <TableCell>Global</TableCell>
                            <TableCell>Product</TableCell>
                            <TableCell>Product Variation</TableCell>
                            {headers?.map((header) => (
                                <TableCell key={header.componentId}>{header.componentName}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                       <TableRow>
                                <TableCell sx={{fontWeight:600}}>Global Service Distribution</TableCell>
                                <TableCell>{countries[0]?.productName}</TableCell>
                                <TableCell>{countries[0]?.productVariationName}</TableCell>
                                {headers?.map((cell) => (
                                    <TableCell key={cell.id}>{
                                        getUtilValue(cell.componentId)
                                    }</TableCell>
                                ))}
                            </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
    );
};
export default GlobalServiceDistribution;